<script>
    import {createEventDispatcher} from 'svelte/internal';
    import AppIcon from "../components/icons/AppIcon.svelte";

    export let title = '';

    const dispatch = createEventDispatcher();

    const onPreviousClick = () => {
        dispatch('click_previous');
    }

    const onNextClick = () => {
        dispatch('click_next');
    }
</script>

<div class="calendar-navigation mb-4">
    <button class="btn nav-left" on:click="{ onPreviousClick }">
        <AppIcon icon="chevron-left" size="18" strokeWidth="2"/>
    </button>
    <h6 class="m-0">{ title }</h6>
    <button class="btn nav-right" on:click="{ onNextClick }">
        <AppIcon icon="chevron-right" size="18" strokeWidth="2"/>
    </button>
</div>

<style>
    .calendar-navigation {
        display: flex;
        align-items: center;
        justify-content: space-between;
        background: #fff;
        border: var(--default-border);
        border-radius: var(--default-border-radius);
    }

    .calendar-navigation .nav-left, .calendar-navigation .nav-right {
        border-radius: 0;
        padding: 10px;
        cursor: pointer;
    }

    .calendar-navigation .nav-left:hover, .calendar-navigation .nav-right:hover {
        background: #e4eaee;
    }

    .calendar-navigation .nav-left {
        border-right: var(--default-border);
    }

    .calendar-navigation .nav-right {
        border-left: var(--default-border);
    }
</style>